import React from 'react';

import type { ConfirmationServiceContextType } from 'components/ConfirmationServiceContext';
import { ConfirmationServiceContext } from 'components/ConfirmationServiceContext';

const useConfirmation = (): ConfirmationServiceContextType => React.useContext(ConfirmationServiceContext);

export default useConfirmation;
